// src/routes/MainRoutes.tsx
import ProtectedRoute from "./ProtectedRoute.tsx";
import MainPage from "../pages/MainPage.tsx";
import UpdatesAndFaqPage from "../pages/UpdatesAndFaqPage.tsx";
import UpdatesAndFaqPageIframe from "../pages/UpdatesAndFaqPageIframe.tsx";

const MainRoutes = {
  element: <ProtectedRoute/>,
  children: [
    {path: "/", element: <MainPage/>},
    // {path: "/updates-and-faq", element: <UpdatesAndFaqPage/>},
    {path: "/updates-and-faq", element: <UpdatesAndFaqPageIframe/>},
  ],
};

export default MainRoutes;
